export default "__VITE_ASSET__CaMtYyAc__"